<template>
  <div class="w-2/5 flex items-center px-1 text-xs">
    <span class="mr-2 text-xs">{{ $e("GPS") }}</span>
    {{ GPS }}
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    GPS() {
      return this.config?.drone?.status?.position_state?.gps_number != undefined
        ? this.config.drone.status.position_state.gps_number
        : ENV.NO_DATA;
    },
  },
};
</script>
